import { departmentScope, type DepartmentScopedAccess } from './departmentAccess';

/** One supply record may be used by multiple departments; this never splits stock. */
export interface SupplyDepartmentAssignment {
  departmentIds?: unknown;
}

/** Missing or malformed assignments are unclassified, never implicitly shared with every department. */
export function supplyDepartmentIds(item: SupplyDepartmentAssignment): string[] {
  const ids = item.departmentIds;
  if (!Array.isArray(ids) || ids.length > 100 || ids.some((id) => typeof id !== 'string' || !/^[A-Za-z0-9_-]{1,80}$/.test(id.trim()))) return [];
  return [...new Set(ids.map((id: string) => id.trim()))];
}

export function supplyInDepartment(item: SupplyDepartmentAssignment, departmentId: string): boolean {
  return supplyDepartmentIds(item).includes(departmentId);
}

/** Full-restaurant access can classify all supplies; limited users need an intersection. */
export function canAccessSupply(member: DepartmentScopedAccess, item: SupplyDepartmentAssignment): boolean {
  const scope = departmentScope(member);
  return scope === null || supplyDepartmentIds(item).some((id) => scope.includes(id));
}
